/**
 * Hook for reading the loaded AuthConfig context.
 *
 * Split into its own file so `AuthConfigProvider.tsx` exports only the
 * component — keeps Vite's fast-refresh happy.
 */

import { useContext } from "react";
import { AuthConfigContext } from "./AuthConfigContext";
import type { AuthConfig } from "@/shared/api/auth-config";

export function useAuthConfig(): AuthConfig {
  const config = useContext(AuthConfigContext);
  if (!config) {
    throw new Error(
      "useAuthConfig must be used inside <AuthConfigProvider>; check provider order.",
    );
  }
  return config;
}
